const COLEGIO_SELECCIONADO =
  "extragestor/adjuntarDocumentacion/COLEGIO_SELECCIONADO";
const RESET_COLEGIO_SELECCIONADO =
  "extragestor/adjuntarDocumentacion/RESET_COLEGIO_SELECCIONADO";

const DETALLE_COLEGIO = "extragestor/adjuntarDocumentacion/DETALLE_COLEGIO";
const RESET_DETALLE_COLEGIO =
  "extragestor/adjuntarDocumentacion/RESET_DETALLE_COLEGIO";

const LISTA_RESGUARDOS = "extragestor/adjuntarDocumentacion/LISTA_RESGUARDOS";
const RESET_LISTA_RESGUARDOS =
  "extragestor/adjuntarDocumentacion/RESET_LISTA_RESGUARDOS";

const PROCESO_ENVIO = "extragestor/adjuntarDocumentacion/PROCESO_ENVIO";
const RESET_PROCESO_ENVIO =
  "extragestor/adjuntarDocumentacion/RESET_PROCESO_ENVIO";

const UPLOAD_COMPLETE = "extragestor/adjuntarDocumentacion/UPLOAD_COMPLETE";
const CLEAR_UPLOAD_COMPLETE =
  "extragestor/adjuntarDocumentacion/CLEAR_UPLOAD_COMPLETE";

/*---*/
export {
  COLEGIO_SELECCIONADO,
  RESET_COLEGIO_SELECCIONADO,
  DETALLE_COLEGIO,
  RESET_DETALLE_COLEGIO,
  LISTA_RESGUARDOS,
  RESET_LISTA_RESGUARDOS,
  PROCESO_ENVIO,
  RESET_PROCESO_ENVIO,
  UPLOAD_COMPLETE,
  CLEAR_UPLOAD_COMPLETE
};



// WEBPACK FOOTER //
// ./src/ducks/documentacion/types.js